import { API_BASE_URL } from './api';
import { fetchWithRetry } from './utils/fetchWithRetry';

/** @returns {Record<string, unknown>} */
export function getUiPreferences() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return {};
    const u = JSON.parse(raw);
    return u.ui_preferences && typeof u.ui_preferences === 'object' ? u.ui_preferences : {};
  } catch {
    return {};
  }
}

/**
 * Merge one key under savedFilters (Jobs / Invoices / Clients list state).
 * @param {'jobs'|'invoices'|'clients'|'estimates'} key
 * @param {Record<string, unknown>} partial
 */
export async function patchSavedFiltersKey(key, partial) {
  const token = localStorage.getItem('token');
  if (!token) return;

  const curPrefs = getUiPreferences();
  const curSf = curPrefs.savedFilters && typeof curPrefs.savedFilters === 'object' ? curPrefs.savedFilters : {};
  const next = {
    ...curSf,
    [key]: { ...(curSf[key] && typeof curSf[key] === 'object' ? curSf[key] : {}), ...partial },
  };

  const res = await fetchWithRetry(`${API_BASE_URL}user/preferences`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ savedFilters: next }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || data.error || `Save failed (${res.status})`);
  }
  try {
    const raw = localStorage.getItem('user');
    if (raw && data.ui_preferences) {
      const u = JSON.parse(raw);
      u.ui_preferences = data.ui_preferences;
      localStorage.setItem('user', JSON.stringify(u));
    }
  } catch {
    /* ignore */
  }
}
